module.exports = __webpack_public_path__ + "img/avatar.79927252.png";